// extracted by css-extract-rspack-plugin
export default {"boxLink":"SelectProcedure__boxLink--QmM8z","icon":"SelectProcedure__icon--Whax8","title":"SelectProcedure__title--bgJqk","text":"SelectProcedure__text--zkgXi"};